import { getConfigValue } from '@shared/utils/config';
import * as O from 'fp-ts/Option';

const repositoryName = O.getOrElse(() => 'vegetag')(getConfigValue('VITE_PRISMIC_REPOSITORY'));

export function selectAsset<T>(def: T, arc: T): T {
  return repositoryName === 'vegetag' ? def : arc;
}